export default __webpack_public_path__ + "static/media/chai.17070fa0.png";